import { UserInfoModel } from "../../reducers/states/user-info";

export function NameOrEmailUtil(userInfo: UserInfoModel) {
  // Return first and last if it exists, otherwise default to email
  return userInfo.firstName && userInfo.lastName
    ? userInfo.firstName + " " + userInfo.lastName
    : userInfo.email;
}
